import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config'; // Ensure the path points to the new location

const MarketerPage = () => {
  const { marketerId } = useParams(); // Get marketerId from the URL
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const q = query(
          collection(db, 'marketerProducts'),
          where('marketerId', '==', marketerId) // Filter by marketerId
        );
        const querySnapshot = await getDocs(q);
        const productsData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setProducts(productsData);
      } catch (err) {
        console.error('Error fetching marketer products:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [marketerId]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="marketer-page">
      <h1>Marketer Products</h1>
      {products.length === 0 ? (
        <p>No products found for this marketer.</p>
      ) : (
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <h3>{product.name}</h3>
              <p>{product.description}</p>
              <p>Price: ${product.price}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default MarketerPage;
